var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSecurityBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 17 0 17 18 0 18"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1415.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1415.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.66771178,0.137117423 L1.73759566,2.14847817 C0.69776493,2.50100042 -7.70244983e-05,3.46852904 -7.70244983e-05,4.55661721 L-7.70244983e-05,9.51329377 C-7.70244983e-05,9.77959305 0.0399757146,10.0413141 0.123932418,10.2954048 C0.546796914,11.5711997 2.20975583,15.4184231 7.42431437,17.7700975 C8.10444069,18.0768376 8.89548229,18.0768376 9.57637885,17.7700975 C14.7893969,15.4191861 16.4531261,11.5711997 16.8767608,10.2954048 C16.9607175,10.0413141 17,9.77959305 17,9.51253073 L17,4.55661721 C17,3.46852904 16.302158,2.50100042 15.2630976,2.14847817 L9.33221119,0.137117423 C8.7930397,-0.0460110216 8.20688327,-0.0460110216 7.66771178,0.137117423",
    id: "Fill-1",
    fill: "#2DABFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.08087119,9.61134379 L7.89293142,9.79676134 C7.56711779,10.1172361 7.04104047,10.1164731 6.71599708,9.79447223 L6.53190853,9.61134379 L5.16857491,8.26077151 C4.64326783,7.74038152 3.74516218,8.10892751 3.74516218,8.84525646 C3.74516218,9.06424756 3.83297011,9.27408224 3.98932984,9.42897838 L6.71599708,12.1301229 C6.87235681,12.2850191 7.08494443,12.3720051 7.30600474,12.3720051 C7.52783529,12.3720051 7.74042291,12.2850191 7.89678264,12.1301229 L13.0112093,7.03915218 C13.1675691,6.88425604 13.255377,6.67442136 13.255377,6.45543027 C13.255377,5.71986435 12.3572713,5.35131836 11.8319643,5.87170835 L8.08087119,9.61134379 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurityBlue);
export default __webpack_public_path__ + "static/media/icon_security_blue.813690cfd6a99f5d577d06fb729bdab0.svg";
export { ForwardRef as ReactComponent };